export default function RecentBlog(data) {
    const cardData = data.data;
    return (
        <>
            <section class="post-widget clearfix">
                <div class="post-widget__media"><a href={"./"+cardData.url}><img class="img-fluid" src={"/images/blog/"+cardData.url+".png"} alt="foto" /></a></div>
                <div class="post-widget__inner">
                    <h2 class="post-widget__title"><a href={"./"+cardData.url}>{cardData.title}</a></h2>
                    <div class="post-widget__date">
                        <time datetime={cardData.date}>{cardData.date}</time>
                    </div>
                </div>
            </section>
        </>
    );
}